import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { IMemoDatatable, MemoDatatableMeta } from './MemoDatatableHandlerMeta';

export default function MemoDatatableHandler() {
  // const editUsersModal = React.useRef<any>(null);
  // const deleteUsersModal = React.useRef<any>(null);

  const data: IMemoDatatable[] = [
    {
      from: '',
      memo: '',
      activationDate: '',
      purgeDate: '',
    },
    {
      from: '',
      memo: '',
      activationDate: '',
      purgeDate: '',
    },
    {
      from: '',
      memo: '',
      activationDate: '',
      purgeDate: '',
    },
  ];

  // const handleEdit = (row: any) => {
  //   editUsersModal?.current?.onOpen();
  // };

  // const handleDelete = (row: any) => {
  //   deleteUsersModal?.current?.onOpen();
  // };

  return (
    <>
      <CustomReactTable data={data} columns={MemoDatatableMeta.columns()} />

      {/* <CustomAppModal
        title="Editer Le Status des utilisateurs"
        ref={editUsersModal}
        actionBtnText="Editer"
        actionBtnClick={() => editUsersModal?.current?.onClose()}
      >
        <CustomFormControl label="Status">Edit Form</CustomFormControl>
      </CustomAppModal> */}

      {/* <CustomAppModal
        title="Confirmer la suppression"
        ref={deleteUsersModal}
        actionBtnText="Supprimer"
        actionBtnClick={() => deleteUsersModal?.current?.onClose()}
      >
        <CC.Text>Voulez-vous vraiment supprimer ?</CC.Text>
      </CustomAppModal> */}
    </>
  );
}
